<template>
  <div>
    <v-row>
      <v-col cols="12" md="9" sm="12">
        <div>
          <!-- Print Only -->
          <HeaderPrint />
          <!-- / Print Only -->
          <v-card>
            <div class="pa-2 d-print-none">
              <v-row no-gutters class="align-center">
                <v-col cols="6" md="9">
                  <div class="text-left d-md-none">
                    <v-btn-toggle dense>
                      <v-btn @click="breakpoint = 0">
                        <v-icon>mdi-view-list</v-icon>
                      </v-btn>
                      <v-btn @click="breakpoint = 'xs'">
                        <v-icon>mdi-view-grid</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
                <v-col cols="6" md="3">
                  <v-text-field
                    :class="$vuetify.breakpoint.smAndDown ? '' : ''"
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('search')"
                    single-line
                    hide-details
                    dense
                    solo-inverted
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="data"
              :search="search"
              :items-per-page="10"
              item-class="text--red"
              :sort-by="'sum'"
              :sort-desc="true"
              :mobile-breakpoint="breakpoint"
              :footer-props="{
                'items-per-page-text': this.$t('rowsPerPage'),
              }"
            >
              <template v-slot:item.cotacao="{ item }">
                <v-select
                  v-model="item.model"
                  class="mt-4"
                  style="width: 150px; height: 56px"
                  :items="item.select"
                  :label="item.select[0].name"
                  item-key="id"
                  item-text="name"
                  item-value="value"
                  solo-inverted
                  dense
                  filled
                ></v-select>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn-toggle dense>
                  <v-btn
                    small
                    :title="$t('add')"
                    @click="add(item)"
                    class="info"
                  >
                    <v-icon size="24" color="white">mdi-plus</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-col>

      <!-- COMBINAÇÃO -->
      <v-col cols="12" md="3" sm="12">
        <div id="print-report">
          <!-- Print Only -->
          <div class="d-none d-print-block caption">
            <HeaderPrint />
          </div>

          <v-card>
            <v-toolbar dense elevation="0">
              <v-toolbar-title class="body-1">{{
                $t("combination")
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>

            <div v-show="this.operatorCredit > 0" class="my-1">
              <v-subheader>{{ $t('TypeBet') }}</v-subheader>
              <v-select
                class="px-4 pt-2"
                v-model="selectedOption"
                :items="options" 
                item-text="label"
                item-value="value"
                :disabled="eventsSelecteds.length == 0"
                outlined
                dense
              ></v-select>
            </div>

            <v-card-text
              class="px-2 pt-2 pb-1"
              :class="$vuetify.theme.dark ? '' : 'grey lighten-2'"
            >
              <v-card
                class="pa-2 mb-2"
                :class="
                  $vuetify.theme.dark
                    ? 'white black--text'
                    : 'black white--text'
                "
                v-for="(event, index) in eventsSelecteds"
                :key="index"
              >
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="caption">{{ event.description }}</div>
                    <div class="caption font-weight-bold">
                      {{ event.outcome }}
                    </div>
                  </div>
                  <div>
                    <v-icon
                      class="d-print-none"
                      :class="
                        $vuetify.theme.dark ? 'black--text' : 'white--text'
                      "
                      size="24"
                      v-on:click="closeEventSelected(index)"
                      >mdi-close-circle-outline</v-icon
                    >
                  </div>
                </div>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card elevation="0">
              <v-subheader>{{ $t("combinationAnalysis") }} </v-subheader>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item, index) in itemsAnalyze" :key="index">
                      <td>{{ item.name }}</td>
                      <td class="text-right">
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-actions class="d-print-none">
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  small
                  v-on:click="analyzeCombination(1)"
                  :disabled="eventsSelecteds.length == 0 || !canAnalyzeCombination"
                  >{{ $t("exactly") }}</v-btn
                >
                <v-btn
                  color="success"
                  small
                  v-on:click="analyzeCombination(0)"
                  :disabled="eventsSelecteds.length == 0 || !canAnalyzeCombination"
                  >{{ $t("combination") }}</v-btn
                >
              </v-card-actions>
            </v-card>
            <v-divider class="my-4"></v-divider>
            <v-card elevation="0">
              <v-subheader>{{ $t("simulationOnProvider") }}</v-subheader>
              <v-simple-table dark>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item, index) in itemsSimulation" :key="index">
                      <td>{{ item.name }}</td>
                      <td class="text-right">
                        {{ item.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-actions class="d-print-none">
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  small
                  v-on:click="simulation(1)"
                  :disabled="eventsSelecteds.length == 0 || !canSimulation"
                  >{{ $t("exactly") }}</v-btn
                >
                <v-btn
                  color="success"
                  small
                  v-on:click="simulation(0)"
                  :disabled="eventsSelecteds.length == 0 || !canSimulation"
                  >{{ $t("combination") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "collaborator-reports-expense",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    data: [],
    sum_bets: 0,
    selected: "",
    idsSelecteds: [],
    eventsSelecteds: [],
    itemsSimulation: [],
    itemsAnalyze: [],
    breakpoint: "xs",
    selectedOption: '',
    options: [],
    operatorRetail: "",
    operatorCredit: "",    
  }),
  created() {
    this.operatorRetail = localStorage.getItem("operator-retail")
    this.operatorCredit = localStorage.getItem("operator-credit")
    this.betTypes();
  },

  computed: {
    itemsSimulations() {
      return [
        { name: this.$t("qtyBet") },
        { name: this.$t("betting") },
        { name: this.$t("youtReturnWouldBe") },
      ];
    },
    headers() {
      return [
        { text: this.$t("qtyBet"), value: "sum", align: "center" },
        { text: this.$t("countryLeague"), value: "tournaments_name" },
        { text: this.$t("event"), value: "description" },
        { text: this.$t("odd"), value: "cotacao" },
        { text: this.$t("add"), value: "action", align: "center" },
      ];
    },
    canAnalyzeCombination() {
      return this.$permission("74");
    },
    canSimulation() {
      return this.$permission("75");
    },
  },

  async mounted() {
    const request = await this.$request.get(
      "/colab/report/lossPrevention"
    );
    const events = await request.dados.events;

    events.forEach((event) => {
      let sum = [];
      let select = [];
      event.outcomes.forEach((item) => {
        sum.push(Number(item.sum_bets));
        if (!select.includes(item.id_outcome)) select.push(item.id_outcome);
      });
      event.sum = sum.reduce((a, b) => a + b, 0);
      event.select = select.map((item) => ({
        name: this.getOutcome(item),
        value: item,
      }));
      event.model = event.outcomes[0].id_outcome;
    });

    this.data = events;
  },

  methods: {
    betTypes(){
      if (this.operatorCredit == 0) {
        this.options.push(
          { label: this.$t("allBets"), value: '' }
          )
      }
      if (this.operatorCredit == 1) {
        this.options.push(
          { label: this.$t("allBets"), value: '' },
          { label: this.$t("agentBet"), value: 0 },
          { label: this.$t("onlineBetting"), value: 1 },
          )
      }
      if (this.operatorCredit == 2 && this.operatorRetail == 0) {
        this.options.push(
          { label: this.$t("allBets"), value: '' },
          { label: this.$t("bonusBet"), value: 2 },
          { label: this.$t("onlineBetting"), value: 1 },
          )
      }
      if (this.operatorCredit == 2 && this.operatorRetail > 0) {
        this.options.push(
          { label: this.$t("allBets"), value: '' },
          { label: this.$t("bonusBet"), value: 2 },
          { label: this.$t("onlineBetting"), value: 1 },
          { label: this.$t("agentBet"), value: 0 },
          )
      }
    },
    getOutcome(idOutcome) {
      const outcome = this.$infoTable.outcomes(idOutcome).name_outcome;
      return outcome;
    },

    add(data) {
      if (!data) return;
      const { idsSelecteds, eventsSelecteds } = this;
      if (!idsSelecteds.includes(data.id)) {
        idsSelecteds.push(data.id);
        eventsSelecteds.push({
          id: data.id,
          description: data.description,
          id_outcome: data.model,
          outcome: this.$infoTable.outcomes(data.model).name_outcome,
        });
      }
    },

    closeEventSelected(index) {
      this.idsSelecteds.splice(index, 1);
      this.eventsSelecteds.splice(index, 1);
    },

    async analyzeCombination(exactly) {
      const body = {
        qtd_events: this.eventsSelecteds.length,
        exactly,
        debit_credit: this.selectedOption
      };

      this.eventsSelecteds.map((item, index) => {
        body[`id_event[${index}]`] = item.id;
        body[`id_outcome[${index}]`] = item.id_outcome;
      });

      const request = await this.$request.post(
        "/colab/report/analyzeCombination",
        body
      );
      const analyze = request.dados[0];
      this.itemsAnalyze = [
        {
          name: this.$t("qtyBets"),
          value: analyze.sum_bets,
        },
        {
          name: this.$t("amountBet"),
          value: `${analyze.total_value || 0}`,
        },
        {
          name: this.$t("possibleReturn"),
          value: `${analyze.total_prize || 0}`,
        },
        {
          name: this.$t("totalCommission"),
          value: `${analyze.total_comission || 0}`,
        },
      ];
    },

    async simulation(exactly) {
      const body = {
        qtd_events: this.eventsSelecteds.length,
        exactly,
        debit_credit: this.selectedOption
      };

      this.eventsSelecteds.map((item, index) => {
        body[`id_event[${index}]`] = item.id;
        body[`id_outcome[${index}]`] = item.id_outcome;
      });

      const request = await this.$request.post(
        "/colab/report/simulation",
        body
      );
      const simulation = request.dados;
      this.itemsSimulation = [
        {
          name: this.$t("qtyBets"),
          value: simulation.total_bets,
        },
        {
          name: this.$t("betting"),
          value: `${simulation.value_bet || 0}`,
        },
        {
          name: this.$t("youtReturnWouldBe"),
          value: `${simulation.value_prize || 0}`,
        },
      ];
    },
  },
};
</script>
